import { z } from 'zod/v4';

import { hoverEffectsSchemaLegacy, menuItemSchemaLegacy } from '../../../common/schemas/legacy';

/**
 * Data shape for the `navigation` widget — the header/footer-only sibling of `menu`, same
 * menu-list/typography/layout fields, minus `menu`'s embedded-logo group (navigation never renders
 * one; that is exclusively the standalone `logo` widget's job when the two are placed side by side
 * in a header).
 *
 * **`fontStyle`/`submenuFontStyle` are spelled correctly here** — unlike `menu`'s
 * `fontStile`/`submenuFontStile`, which is a real typo in that widget's persisted field name. Two
 * different widgets, two different spellings of the same concept; do not swap them.
 */
export const navigationLegacyDataSchema = z.object({
    menuList: z.array(menuItemSchemaLegacy),
    textColor: z.string(),
    submenuTextColor: z.string().nullish(),
    fontSize: z.number(),
    submenuFontSize: z.number().nullish(),
    menuItemIndent: z.enum(['S', 'M', 'L']),
    horizontalPosition: z.enum(['L', 'M', 'R']),
    fontStyle: z.array(z.enum(['I', 'B', 'AT'])),
    submenuFontStyle: z.array(z.enum(['I', 'B', 'AT'])).nullish(),
    submenuListBackground: z.string().nullish(),
    layoutDirection: z.enum(['Horizontal', 'Vertical']),
    hoverEffects: hoverEffectsSchemaLegacy,
});
